import React, { useEffect, useState } from "react";

function OrientationGuard({ children }) {
  const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detect mobile or tablet
    const checkIfMobile = () => {
        // debugger
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const mobile =
        /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
      setIsMobile(mobile);
    };

    checkIfMobile();

    const handleOrientationChange = () => {
      setIsPortrait(window.innerHeight > window.innerWidth);
    };

    window.addEventListener("resize", handleOrientationChange);
    window.addEventListener("orientationchange", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);

  // ✅ Only block if it's a mobile device AND portrait orientation
  if (isMobile && !isPortrait) {
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          background: "#000",
          color: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
          padding: "20px",
          zIndex: 9999,
          position: "fixed",
          top: 0,
          left: 0,
        }}
      >
        <h2 style={{ marginBottom: "10px" }}>Please rotate your device</h2>
        <p>This application works best in landscape mode.</p>
      </div>
    );
  }

  return children;
}

export default OrientationGuard;
